import * as React from 'react';
import Box from '@mui/joy/Box';
import Typography from '@mui/joy/Typography';
import ArrowUpwardRoundedIcon from '@mui/icons-material/ArrowUpwardRounded';
import ArrowDownwardRoundedIcon from '@mui/icons-material/ArrowDownwardRounded';

export type DeltaProps = { current: number; previous: number; invertColor?: boolean; invertArrow?: boolean, hideZeroPercent?: boolean };

export const Delta: React.FC<DeltaProps> = React.memo(({ current, previous, invertColor, hideZeroPercent }) => {
    const pct = React.useMemo(() => {
        if (!previous) return 0;
        return ((current - previous) / Math.abs(previous)) * 100;
    }, [current, previous]);

    if ((!isFinite(pct) || pct === 0) && !hideZeroPercent) {
        return <Typography level="body-sm">0%</Typography>;
    }

    const isPositive = invertColor ? pct >= 0 : pct > 0;
    const color = (isPositive ?? false) !== (invertColor ?? false)
        ? 'success.600'
        : 'danger.600';
    return (
        <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5, color }}>
            {isPositive ? <ArrowUpwardRoundedIcon fontSize="small"/> : <ArrowDownwardRoundedIcon fontSize="small"/>}
            { pct === 0 && hideZeroPercent
            ? <></>
            : <Typography level="body-sm" sx={{ color }}>
                {pct.toFixed(2)}%
             </Typography>}
        </Box>
    );
});

Delta.displayName = 'Delta';


